import type { ReduxApplicationState } from '../combinedReducer';

export const selectProductReviews = (state: ReduxApplicationState) => state.reviews;

// The summary selectors are the data layer's read API for the ReviewsSummary
// component (DISC-4325's split, consumed from DISC-4326).
export const selectAiSummary = (state: ReduxApplicationState) => state.reviews.aiSummary;

export const selectProductInsights = (state: ReduxApplicationState) =>
  state.reviews.productInsights;

export const selectRatingBreakdown = (state: ReduxApplicationState) =>
  state.reviews.ratingBreakdown;

/** The rar-data-api list's own average, the fallback when Feefo has not settled. */
export const selectListAverageRating = (state: ReduxApplicationState) =>
  state.reviews.averageProductRating;
